import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Link as LoftLink } from "@xometry/xometry_loft";

export const ContentHubCategoryBase = styled.div`
  border-top: 1px solid ${theme.colors.darkBlues[25]};
  padding: 32px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${theme.largerThan.lg} {
    padding: 60px 0;
  }
`;

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 8px;
`;

export const Description = styled.h4`
  flex-basis: 100%;
  margin-top: 0;
  margin-bottom: 0;
`;

export const Link = styled(LoftLink)`
  align-self: center;
  margin: 8px 0 0 0;
  font-size: 16px;
  line-height: 24px;
  order: 1;

  ${theme.largerThan.lg} {
    order: initial;
    margin: 0 0 8px 0;
  }
`;

export const Posts = styled.div`
  flex-basis: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  margin-top: 24px;

  ${theme.largerThan.lg} {
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-row-gap: 48px;
    margin-top: 44px;
  }
`;

export const SmallPostContainer = styled.div`
  height: 258px;

  ${theme.largerThan.lg} {
    height: 315px;
  }
`;
